import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { TagManagementPayload } from './tagManagement.types';

const createTagManagement = (client: AxiosInstance) => async (payload: TagManagementPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.ADD_TAG_MANAGEMENT, payload)).data;
};

export const tagManagementMutations = {
  createTagManagement,
};
